<script lang="ts" setup>
import { useTranslations } from '~/composables/translations';
import Carousel from '~/components/uikit/Carousel.vue';

import type { FAQMenuContent } from '~/models/faq_models';

const props = defineProps<{
  content: FAQMenuContent[];
  activeContent?: FAQMenuContent;
  module: string;
}>();
const { $i18n } = useTranslations(props.module);
</script>
<template>
  <div class="faq-content flex-grow-1">
    <div class="current-faq-category pa-10px">
      <span :class="`fonticon ${activeContent?.icon}`" class="blue-3--text" />
      {{ $i18n(activeContent?.title || '') }}
    </div>
    <div class="pa-10px">
      <div v-for="link in activeContent?.articles" :key="link.title + 'article'">
        <h3 :data-title="link.url">
          {{ $i18n(link.title) }}
        </h3>
        <template v-for="i in 10">
          <p
            v-if="
              $i18n(link.title + i) !== `__${link.title + i}__` &&
              $i18n(link.title + i) !== link.title + i
            "
            v-html="$i18n(link.title + i)"
            :key="`${link.url}-article-${i}`"
            class="text-justify"
          />
        </template>
        <template v-if="link.images && link.images.length > 1">
          <Carousel
            :images="link.images.map((el) => `/webapps/MP3DPMakeVue/assets/images/${module}/${el}`)"
          />
        </template>
        <template v-if="link.images && link.images.length === 1">
          <img :src="`/webapps/MP3DPMakeVue3/assets/images/${module}/${link.images[0]}`" />
        </template>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.faq-content {
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  background-color: white;
  max-width: 100vw;
  position: relative;

  @include variables.for-sm {
    border: 0;
  }
}

.faq-content img {
  max-width: 100%;
}

.current-faq-category {
  position: sticky;
  top: 0;
  background: white;
  background: #f1f1f1;
  padding: 20px;
  text-transform: uppercase;
  font-weight: normal;
  font-size: 1.7em;
  z-index: 1;

  @include variables.for-sm {
    font-size: 1.5em;
    padding: 15px;
  }

  @include variables.for-xs {
    font-size: 1em;
    padding: 15px;
  }
}

h3 {
  font-size: 1.5em;

  @include variables.for-xs {
    font-size: 1em;
  }
}
</style>
